import { ModelDetails } from '../configuration/model-description';
import { Link } from 'react-router-dom';

function ModelCards(props: { onlyModels?: string[], exceptModels?: string[] }) {
  return (
    <div className="d-flex flex-nowrap overflow-auto gap-2 pb-2 mb-2">
      {Object.keys(ModelDetails)
        .filter(x => !props.onlyModels || props.onlyModels.includes(x))
        .filter(x => !props.exceptModels || !props.exceptModels.includes(x))
        .map((model, i) => (
          <Link className="card flex-shrink-0 model-card link-secondary text-decoration-none text-dark" to={`/m/levis-${model}/`} title={`Джинси Levi’s ${model}`}>
            <img src={ModelDetails[Number(model)]?.imageCatalog} loading="lazy" className="card-img-top" alt={`Джинси Levi’s ${model}`} />
            <div className="card-body p-2">
              <span className="h6 d-block mb-1">Levi’s {model}</span>
              <p className="mb-0">{ModelDetails[Number(model)].fitDescription}</p>
            </div>
          </Link>
        ))}
    </div>
  );
}

export default ModelCards;
